"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringToHTML = void 0;
var React = require("react");
var StringToHTML = function (htmlString, ref, className) {
    if (ref === void 0) { ref = null; }
    if (className === void 0) { className = ''; }
    return (React.createElement("span", { className: className, ref: ref, dangerouslySetInnerHTML: { __html: htmlString } }));
};
exports.StringToHTML = StringToHTML;
